export default "__VITE_ASSET__DWkltd15__"